import React from 'react';
import {FieldProp} from '../../types';

type SectionProps = FieldProp & {};

export const Section: React.FunctionComponent<SectionProps> = ({
                                                                   field,
                                                                   locale = 'en-US'
                                                               }): JSX.Element => {

    const fieldLabel = (
        field.hasOwnProperty('translations') &&
        field.translations.hasOwnProperty(locale) &&
        field.translations[locale].hasOwnProperty('label') &&
        field.translations[locale].label
    ) ? field.translations[locale].label : field.label;

    return (
        <h2 className="section-title">{fieldLabel}</h2>
    );
};